import {axios} from "@/utils/axios";
import {getHospitalListAPIUrl,getDictionaryListUrl,getQRCodeUrl} from "@/api/urlConfig"

export function getHospitalListAPI(parameter) {
    return axios({
        url: getHospitalListAPIUrl,
        method: 'POST',
        data: parameter
    })
}


export function getQRCode(parameter) {
    return axios({
        url: getQRCodeUrl,
        method: 'POST',
        data: parameter
    })
}

export function getDictionaryList(parameter) {
    return axios({
        url: getDictionaryListUrl,
        method: 'POST',
        data: {appKey:'a2c109f66bdbd1f8',sign:'MzFiN2IwNmFjYmE1MDgwMjAxYzc2MmZjMjFhMDRmM2ZhZTAyZTM3YThkYjQ5NTIzZjc4N2M4NThjZmI2ZmRjNA=='}
    })
}

export function getDictionaryMapByName(name){
    let dictionaryList = []
    try{//获取成功
        dictionaryList=JSON.parse(localStorage.getItem('dictionaryList'))
    }catch (e){
        getDictionaryList().then((res)=>{
            if(res.code ===1){
                localStorage.setItem('dictionaryList', JSON.stringify(res.data))
                dictionaryList = res.data
            }else {
                console.log('字典获取失败')
            }
        })
    }
    let data =dictionaryList.find(item => item.name === name).options
    let dataMap = {}
    data.forEach((item) => {
        dataMap[item.key] = item.value;
    });
    return dataMap
}
